// extracted by mini-css-extract-plugin
module.exports = {"trendBox":"trendIndicatorBox_trendBox__35bOQ","trendIcon":"trendIndicatorBox_trendIcon__1iE6W"};